// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__6Nvrx","paramInput":"JobSimulator_paramInput__1VYyK","input":"JobSimulator_input__2YWrv"};